import { render, staticRenderFns } from "./LinkageDetail.vue?vue&type=template&id=4a015104&scoped=true&"
import script from "./LinkageDetail.vue?vue&type=script&lang=js&"
export * from "./LinkageDetail.vue?vue&type=script&lang=js&"
import style0 from "./LinkageDetail.vue?vue&type=style&index=0&id=4a015104&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a015104",
  null
  
)

export default component.exports